<template>
  <li class="glide__slide" tabindex="-1">
    <slot />
  </li>
</template>

<script>
import { inject, onMounted } from 'vue';
import { uuid } from 'vue-uuid';
export default {
  setup() {
    const id = uuid.v1();

    const registerItem = inject('scroller/registerItem', () => {});

    onMounted(() => {
      registerItem(id);
    });
  },
};
</script>
